<template>
  <div class="upload-audio" @click.stop="uploadAudio">
    <template v-if="!Boolean($slots.default)">
      <div class="upload-icon">
        <i class="iconfont icon-tianjia"></i>
      </div>
      <!-- <div class="upload-desc">上传</div> -->
    </template>
    <template v-else>
      <slot></slot>
    </template>
    <input
      ref="uploadAudio"
      style="display: none;"
      type="file"
      accept="audio/*"
      @change="uploadFile"
      @click.stop="() => {}"
    />
    <el-dialog title="编辑音频" append-to-body width="400px" :visible.sync="dialogVisible" :before-close="handleClose">
      <el-form ref="form" :model="form" label-width="50px">
        <el-form-item label="url">
          <el-input v-model="form.url"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleUpload">手动上传</el-button>
        <el-button type="primary" @click="handleEdit">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// upload
import { uploadFile } from "@/plugins/uploadFile";
// element-ui
import { Message } from "element-ui";

export default {
  name: "UploadImage",
  props: {
    type: {
      type: String,
      default: "add"
    },
    data: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        url: ""
      }
    };
  },

  mounted() {},

  methods: {
    uploadAudio() {
      if (this.type == "edit") {
        this.dialogVisible = true;
        this.form.url = this.data;
        return;
      }
      this.$refs.uploadAudio.click();
    },
    handleUpload() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.$refs.uploadAudio.click();
      });
    },
    handleEdit() {
      this.dialogVisible = false;
      this.$emit("onUploaded", this.form.url);
    },
    handleClose() {
      this.dialogVisible = false;
      this.form = {
        url: ""
      };
    },
    async uploadFile(e) {
      const file = e.target.files[0];
      if (!file) return;
      try {
        let params = {
          file: file,
          fileType: "audio",
          progressCb: percent => {
            // percent = percent === 100 ? 99 : percent;
            // this.percent = percent;
          }
        };
        // console.log(params);
        const res = await uploadFile(params);
        const url = res.url;
        this.$emit("onUploaded", url);
      } catch (error) {
        Message({
          message: "音频上传错误！",
          type: "error"
        });
        console.log(error);
      }
      // 重置上传器
      this.$refs.uploadAudio.value = "";
    }
  }
};
</script>

<style lang="less" scoped>
.upload-audio {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #727c86;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  vertical-align: top;
  .upload-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.18);
    text-align: center;
    line-height: 32px;
    font-size: 18px;
    color: #fff;
  }
  .upload-desc {
    margin-top: 12px;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
    line-height: 17px;
  }
}
</style>
